// import React, { useEffect, useState } from 'react';
// import CookieConsent, { Cookies } from 'react-cookie-consent';
// import clsx from 'clsx';

// import { pathToPrivacyPolicy } from '../../../utils/paths';
// import {
//   COOKIE_ACCEPT,
//   COOKIE_DECLINE,
//   COOKIE_EXPIRATION_DAYS,
//   COOKIE_EXPIRATION_DAYS_EU,
//   GTM_COOKIE_NAME,
//   CLARITY_COOKIE_NAME,
//   COOKIE_CONSENT_NAME,
// } from '../../../utils/cookie-consts';
// import { ENGLISH_LANGUAGE, LOCALES_CODES } from '../../../utils/consts';
// import Modal from '../../ui/react-portal/Modal';
// import { ButtonBorderGradient } from '../button-border-gradient';
// import { CookieConsentForm } from './CookieConsentForm';

// const API_URL = process.env.GATSBY_API_URL;

// const EU = [
//   'AT',
//   'BE',
//   'BG',
//   'HR',
//   'CY',
//   'CZ',
//   'DK',
//   'EE',
//   'FI',
//   'FR',
//   'DE',
//   'GR',
//   'HU',
//   'IE',
//   'IT',
//   'LV',
//   'LT',
//   'LU',
//   'MT',
//   'NL',
//   'PL',
//   'PT',
//   'RO',
//   'SK',
//   'SI',
//   'ES',
//   'SE',
//   'XX',
// ];

// const cookieBannerText: Record<
//   string,
//   {
//     accept: string;
//     settings: string;
//     privacyPolicy: string;
//     cookieBanner: string;
//   }
// > = {
//   en: {
//     accept: 'Accept',
//     settings: 'Settings',
//     privacyPolicy: 'Privacy Policy',
//     cookieBanner:
//       'We use cookies to analyze how visitors use our website. You can accept all cookies or manage your preferences. For more details, please review our ',
//   },
//   de: {
//     accept: 'Akzeptieren',
//     settings: 'Einstellungen',
//     privacyPolicy: 'Datenschutzerklärung',
//     cookieBanner:
//       'Wir verwenden Cookies, um zu analysieren, wie Besucher unsere Website nutzen. Sie können alle Cookies akzeptieren oder Ihre Einstellungen verwalten. Weitere Details finden Sie in unserer ',
//   },
//   es: {
//     accept: 'Aceptar',
//     settings: 'Configuración',
//     privacyPolicy: 'Política de privacidad',
//     cookieBanner:
//       'Utilizamos cookies para analizar cómo los visitantes utilizan nuestro sitio web. Puedes aceptar todas las cookies или gestionar tus preferencias. Para más detalles, consulte nuestra ',
//   },
//   fr: {
//     accept: 'Accepter',
//     settings: 'Paramètres',
//     privacyPolicy: 'Politique de confidentialité',
//     cookieBanner:
//       'Nous utilisons des cookies pour analyser la manière dont les visiteurs utilisent notre site web. Vous pouvez accepter tous les cookies ou gérer vos préférences. Pour plus de détails, veuillez consulter notre ',
//   },
//   da: {
//     accept: 'Accepter',
//     settings: 'Indstillinger',
//     privacyPolicy: 'Privatlivspolitik',
//     cookieBanner:
//       'Vi bruger cookies til at analysere, hvordan besøgende bruger vores hjemmeside. Du kan acceptere alle cookies eller administrere dine præferencer. For flere oplysninger, se venligst vores ',
//   },
//   nb: {
//     accept: 'Godta',
//     settings: 'Innstillinger',
//     privacyPolicy: 'Personvernerklæring',
//     cookieBanner:
//       'Vi bruker informasjonskapsler for å analysere hvordan besøkende bruker nettstedet vårt. Du kan godta alle informasjonskapsler eller administrere dine innstillinger. For mer informasjon, vennligst se vår ',
//   },
//   sv: {
//     accept: 'Acceptera',
//     settings: 'Inställningar',
//     privacyPolicy: 'Integritetspolicy',
//     cookieBanner:
//       'Vi använder cookies för att analysera hur besökare använder vår webbplats. Du kan acceptera alla cookies eller hantera dina inställningar. För mer information, se vår ',
//   },
// };

// const getLangFromUrl = () => {
//   const lang = window.location.pathname.split('/')[1];

//   return Object.keys(LOCALES_CODES).includes(lang) ? lang : ENGLISH_LANGUAGE;
// };

// const CustomButtonGradient = ({
//   children,
//   onClick,
// }: {
//   children: React.ReactNode;
//   onClick?: () => void;
// }) => {
//   const language = getLangFromUrl();
//   const isSettings = children === cookieBannerText[language].settings;

//   return (
//     <div
//       className={clsx(
//         'w-[120px] h-[40px] p-0.5 rounded-[50px] group bg-gradient-button-border',
//         'mobile:h-[30px]',
//       )}
//     >
//       <button
//         type="button"
//         onClick={onClick}
//         className={clsx(
//           'group/item w-full h-full block text-sm font-medium tracking-tight rounded-[50px] px-5 py-[3px] flex items-center justify-center gap-1.5 overflow-hidden',
//           isSettings &&
//             'bg-midnight-blue text-white group-hover:bg-white group-hover:text-dark-indigo',
//           !isSettings &&
//             'bg-superlight-gray text-dark-indigo group-hover:text-white group-hover:bg-midnight-blue',
//         )}
//       >
//         {children}
//       </button>
//     </div>
//   );
// };

// type CookieBannerProps = {
//   reloadAnalytics: () => void;
//   country: string;
// };

// const CookieBanner = ({ reloadAnalytics, country }: CookieBannerProps) => {
//   const isEU = EU.includes(country.toUpperCase());
//   const language = getLangFromUrl();
//   const isEnglish = language === ENGLISH_LANGUAGE;
//   const langPrefix = isEnglish ? '' : `/${language}`;

//   const [openModal, setOpenModal] = useState(false);
//   const [bannerVisible, setBannerVisible] = useState('byCookieValue');

//   useEffect(() => {
//     const handleScroll = () => {
//       if (!isEU) {
//         Cookies.set(GTM_COOKIE_NAME, COOKIE_ACCEPT, {
//           expires: COOKIE_EXPIRATION_DAYS,
//         });
//         Cookies.set(CLARITY_COOKIE_NAME, COOKIE_ACCEPT, {
//           expires: COOKIE_EXPIRATION_DAYS,
//         });
//         reloadAnalytics();
//       }
//       window.removeEventListener('touchstart', handleScroll);
//       window.removeEventListener('mousemove', handleScroll);
//       window.removeEventListener('wheel', handleScroll);
//     };

//     window.addEventListener('mousemove', handleScroll, { passive: true });
//     window.addEventListener('touchstart', handleScroll, { passive: true });
//     window.addEventListener('wheel', handleScroll, { passive: true });

//     return () => {
//       window.removeEventListener('touchstart', handleScroll);
//       window.removeEventListener('mousemove', handleScroll);
//       window.removeEventListener('wheel', handleScroll);
//     };
//   }, [isEU, reloadAnalytics]);

//   if (!isEU) return null;

//   const handleSettings = () => {
//     setOpenModal(true);
//   };

//   const handleAccept = () => {
//     Cookies.set(COOKIE_CONSENT_NAME, COOKIE_ACCEPT, {
//       expires: COOKIE_EXPIRATION_DAYS_EU,
//     });
//     Cookies.set(GTM_COOKIE_NAME, COOKIE_ACCEPT, {
//       expires: COOKIE_EXPIRATION_DAYS_EU,
//     });
//     Cookies.set(CLARITY_COOKIE_NAME, COOKIE_ACCEPT, {
//       expires: COOKIE_EXPIRATION_DAYS_EU,
//     });
//     reloadAnalytics();
//   };

//   const handleDecline = () => {
//     Cookies.set(COOKIE_CONSENT_NAME, COOKIE_DECLINE, {
//       expires: COOKIE_EXPIRATION_DAYS_EU,
//     });
//     Cookies.set(GTM_COOKIE_NAME, COOKIE_DECLINE, {
//       expires: COOKIE_EXPIRATION_DAYS_EU,
//     });
//     Cookies.set(CLARITY_COOKIE_NAME, COOKIE_DECLINE, {
//       expires: COOKIE_EXPIRATION_DAYS_EU,
//     });
//     reloadAnalytics();
//   };

//   const handleSaveConsent = (statisticsEnabled: boolean) => {
//     if (statisticsEnabled) {
//       handleAccept();
//     } else {
//       handleDecline();
//     }

//     setOpenModal(false);
//     setBannerVisible('hidden');
//   };

//   const handleClose = () => {
//     setOpenModal(false);
//   };

//   return (
//     <>
//       <CookieConsent
//         location="bottom"
//         visible={bannerVisible}
//         buttonText={cookieBannerText[language].accept}
//         ButtonComponent={CustomButtonGradient}
//         onAccept={handleAccept}
//         expires={COOKIE_EXPIRATION_DAYS_EU}
//         contentClasses="font-medium !m-0 text-superlight-gray vmobile:!basis-full"
//         containerClasses={clsx(
//           '!w-[70%] mobile:!w-[96%] !bg-dark-blue/95 rounded-2xl text-superlight-gray tracking-tight text-lg mobile:text-base p-[40px] mobile:p-[18px] !items-center flex gap-6 !left-[15%] mobile:!left-[2%] !bottom-[10%]',
//         )}
//       >
//         <div className="flex items-center gap-4 vmobile:flex-col vmobile:items-start">
//           <div>
//             {cookieBannerText[language].cookieBanner}
//             <a
//               href={`${API_URL}${langPrefix}${pathToPrivacyPolicy}`}
//               className="underline text-steel"
//             >
//               {cookieBannerText[language].privacyPolicy}
//             </a>
//             .
//           </div>
//           <div>
//             <ButtonBorderGradient
//               textButton={cookieBannerText[language].settings}
//               sizeClassName="w-[120px] h-[40px] mobile:h-[30px]"
//               onClick={handleSettings}
//             />
//           </div>
//         </div>
//       </CookieConsent>
//       <Modal isOpen={openModal} onClose={handleClose} className="h-[400px]">
//         <CookieConsentForm language={language} onSave={handleSaveConsent} />
//       </Modal>
//     </>
//   );
// };

// export default CookieBanner;
import React, { useEffect } from 'react';
import CookieConsent, { Cookies } from 'react-cookie-consent';
import clsx from 'clsx';

import { pathToPrivacyPolicy } from '../../../utils/paths';
import {
  COOKIE_ACCEPT,
  COOKIE_DECLINE,
  COOKIE_EXPIRATION_DAYS,
  COOKIE_EXPIRATION_DAYS_EU,
  GTM_COOKIE_NAME,
  CLARITY_COOKIE_NAME,
} from '../../../utils/cookie-consts';
import { ENGLISH_LANGUAGE, LOCALES_CODES } from '../../../utils/consts';

const API_URL = process.env.GATSBY_API_URL;

const EU = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'XX',
];

const cookieBannerText: Record<
  string,
  {
    accept: string;
    decline: string;
    privacyPolicy: string;
    cookieBanner: string;
  }
> = {
  en: {
    accept: 'Accept',
    decline: 'Decline',
    privacyPolicy: 'Privacy Policy',
    cookieBanner:
      'We use cookies to analyze how visitors use our website. You can accept or decline all cookies. For more details, please review our ',
  },
  de: {
    accept: 'Akzeptieren',
    decline: 'Ablehnen',
    privacyPolicy: 'Datenschutzerklärung',
    cookieBanner:
      'Wir verwenden Cookies, um zu analysieren, wie Besucher unsere Website nutzen. Sie können alle Cookies akzeptieren oder ablehnen. Weitere Details finden Sie in unserer ',
  },
  es: {
    accept: 'Aceptar',
    decline: 'Rechazar',
    privacyPolicy: 'Política de privacidad',
    cookieBanner:
      'Utilizamos cookies para analizar cómo los visitantes utilizan nuestro sitio web. Puede aceptar o rechazar todas las cookies. Para más detalles, consulte nuestra ',
  },
  fr: {
    accept: 'Accepter',
    decline: 'Refuser',
    privacyPolicy: 'Politique de confidentialité',
    cookieBanner:
      'Nous utilisons des cookies pour analyser la manière dont les visiteurs utilisent notre site web. Vous pouvez accepter ou refuser tous les cookies. Pour plus de détails, veuillez consulter notre ',
  },
  da: {
    accept: 'Accepter',
    decline: 'Afvis',
    privacyPolicy: 'Privatlivspolitik',
    cookieBanner:
      'Vi bruger cookies til at analysere, hvordan besøgende bruger vores hjemmeside. Du kan acceptere eller afvise alle cookies. For flere oplysninger, se venligst vores ',
  },
  nb: {
    accept: 'Godta',
    decline: 'Avslå',
    privacyPolicy: 'Personvernerklæring',
    cookieBanner:
      'Vi bruker informasjonskapsler for å analysere hvordan besøkende bruker nettstedet vårt. Du kan godta eller avslå alle informasjonskapsler. For mer informasjon, vennligst se vår ',
  },
  sv: {
    accept: 'Acceptera',
    decline: 'Avvisa',
    privacyPolicy: 'Integritetspolicy',
    cookieBanner:
      'Vi använder cookies för att analysera hur besökare använder vår webbplats. Du kan acceptera eller avvisa alla cookies. För mer information, se vår ',
  },
  nl: {
    accept: 'Accepteren',
    decline: 'Weigeren',
    privacyPolicy: 'Privacybeleid',
    cookieBanner:
      'We gebruiken cookies om te analyseren hoe bezoekers onze website gebruiken. U kunt alle cookies accepteren of weigeren. Raadpleeg voor meer informatie ons ',
  },
};

const getLangFromUrl = () => {
  const lang = window.location.pathname.split('/')[1];

  return Object.keys(LOCALES_CODES).includes(lang) ? lang : ENGLISH_LANGUAGE;
};

const ButtonBorderGradient = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  const language = getLangFromUrl();
  const isDecline = children === cookieBannerText[language].decline;

  return (
    <div
      className={clsx(
        'w-[120px] h-[40px] p-0.5 rounded-[50px] group bg-gradient-button-border',
        'mobile:h-[30px]',
      )}
    >
      <button
        type="button"
        onClick={onClick}
        className={clsx(
          'group/item w-full h-full block text-sm font-medium tracking-tight rounded-[50px] px-5 py-[3px] flex items-center justify-center gap-1.5 overflow-hidden',
          isDecline &&
            'bg-midnight-blue text-white group-hover:bg-white group-hover:text-dark-indigo',
          !isDecline &&
            'bg-superlight-gray text-dark-indigo group-hover:text-white group-hover:bg-midnight-blue',
        )}
      >
        {children}
      </button>
    </div>
  );
};

type CookieBannerProps = {
  reloadAnalytics: () => void;
  country: string;
};

const CookieBanner = ({ reloadAnalytics, country }: CookieBannerProps) => {
  const isEU = EU.includes(country.toUpperCase());
  const language = getLangFromUrl();
  const isEnglish = language === ENGLISH_LANGUAGE;
  const langPrefix = isEnglish ? '' : `/${language}`;

  useEffect(() => {
    const handleScroll = () => {
      if (!isEU) {
        Cookies.set(GTM_COOKIE_NAME, COOKIE_ACCEPT, {
          expires: COOKIE_EXPIRATION_DAYS,
        });
        Cookies.set(CLARITY_COOKIE_NAME, COOKIE_ACCEPT, {
          expires: COOKIE_EXPIRATION_DAYS,
        });
        reloadAnalytics();
      }
      window.removeEventListener('touchstart', handleScroll);
      window.removeEventListener('mousemove', handleScroll);
      window.removeEventListener('wheel', handleScroll);
    };

    window.addEventListener('mousemove', handleScroll, { passive: true });
    window.addEventListener('touchstart', handleScroll, { passive: true });
    window.addEventListener('wheel', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('touchstart', handleScroll);
      window.removeEventListener('mousemove', handleScroll);
      window.removeEventListener('wheel', handleScroll);
    };
  }, [isEU, reloadAnalytics]);

  if (!isEU) return null;
  return (
    <CookieConsent
      location="bottom"
      buttonText={cookieBannerText[language].accept}
      ButtonComponent={ButtonBorderGradient}
      declineButtonText={cookieBannerText[language].decline}
      enableDeclineButton
      onAccept={() => {
        Cookies.set(GTM_COOKIE_NAME, COOKIE_ACCEPT, {
          expires: COOKIE_EXPIRATION_DAYS_EU,
        });
        Cookies.set(CLARITY_COOKIE_NAME, COOKIE_ACCEPT, {
          expires: COOKIE_EXPIRATION_DAYS_EU,
        });
        reloadAnalytics();
      }}
      onDecline={() => {
        Cookies.set(GTM_COOKIE_NAME, COOKIE_DECLINE, {
          expires: COOKIE_EXPIRATION_DAYS_EU,
        });
        Cookies.set(CLARITY_COOKIE_NAME, COOKIE_DECLINE, {
          expires: COOKIE_EXPIRATION_DAYS_EU,
        });
        reloadAnalytics();
      }}
      expires={COOKIE_EXPIRATION_DAYS_EU}
      buttonWrapperClasses="flex gap-4"
      contentClasses="font-medium !m-0 text-superlight-gray xmobile:!basis-full"
      containerClasses="!w-[70%] mobile:!w-[96%] !bg-dark-blue/95 rounded-2xl text-superlight-gray tracking-tight text-lg mobile:text-base p-[40px] mobile:p-[18px] !items-center flex gap-6 !left-[15%] mobile:!left-[2%] !bottom-[10%]"
    >
      {cookieBannerText[language].cookieBanner}
      <a
        href={`${API_URL}${langPrefix}${pathToPrivacyPolicy}`}
        className="underline text-steel"
      >
        {cookieBannerText[language].privacyPolicy}
      </a>
      .
    </CookieConsent>
  );
};

export default CookieBanner;
